module.exports = __webpack_public_path__ + "static/media/full-screen.b0b0f5ec.svg";